import { RARITY_COLOR as RARITY_HEX } from '@ui/rarity';

// 글자체 단일 출처는 @ui/fonts 다. 여기서 값을 다시 쓰지 않고 **재수출만** 한다 —
// 이 파일을 import 하는 22개 파일의 경로를 안 바꾸려는 호환 장치일 뿐이다.
export { GAME_FONT } from '@ui/fonts';
export const PANEL_BG = 'linear-gradient(180deg, rgba(14, 20, 28, 0.88), rgba(8, 10, 16, 0.86))';
export const BORDER_COLOR = 'rgba(124, 171, 166, 0.45)';
export const GOLD = '#d0b16b';
export const ACCENT = '#67e8d6';
export const GLOW = '0 0 18px rgba(103, 232, 214, 0.18)';

// 경험치 색 — 하단 바·레벨 배지·상태 패널이 같이 쓴다. HP(적)·MP(청)와 겹치지 않는 호박색.
export const XP_HI = '#f2c14e';
export const XP_LO = '#a8620f';
export const XP_TEXT = '#ffe3a3';
// HP 게이지 아틀라스(적색 절반)를 호박색으로 돌리는 필터. StatBarH 와 같은 질감을 쓰기 위함.
export const XP_ATLAS_FILTER = 'hue-rotate(38deg) saturate(1.25) brightness(1.2)';
/** XpFill 을 받는 빈 트랙 — 하단 XP 바의 트랙 색·잔광과 같다. */
export const XP_TRACK_STYLE = {
  position: 'relative', overflow: 'hidden',
  background: 'var(--hud-track, #0c0918)',
  backgroundImage: 'linear-gradient(rgba(120,70,10,0.18), rgba(120,70,10,0.18))',
  boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.9)',
};

// ── 공통 HUD 박스 — 인라인 스타일로 그리는 HUD 조각의 배경 ──────────────────
// 색은 index.css 의 --hud-* 토큰(남보라 잉크 + 금선)을 읽는다 — 장면 테마(uiTheme.js)가 바뀌면 같이 바뀐다.
export const HUD_BORDER = 'rgba(198, 164, 98, 0.38)';

/** 패널 테두리 — **`HUD_BORDER`(0.38)와 알파가 다르다.** 12개 파일이 각자 이 값을 손으로
 *  들고 있었고 전부 같았다(2026-08-22 전수). 즉 이게 「판」의 사실상 표준이고 HUD_BORDER 는
 *  「HUD 상자」의 값이다 — **합치지 마라. 합치면 화면이 바뀐다.**
 *  이름을 준 이유는 하나다: 종전엔 12곳을 다 찾아야 바꿀 수 있었고, 한 곳을 놓쳐도
 *  에러가 안 났다(실제로 「금색 통일」 리팩터가 세 파일을 놓친 걸 아무도 몰랐다). */
export const PANEL_BORDER = 'rgba(198, 164, 98, 0.30)';
export const HUD_BOX = {
  background: 'linear-gradient(180deg, var(--hud-panel-hi, rgba(28,22,56,0.92)), var(--hud-panel-lo, rgba(10,7,22,0.94)))',
  border: `1px solid ${HUD_BORDER}`,
  borderRadius: '4px',
  boxShadow: 'inset 0 1px 0 rgba(232,202,140,0.14), 0 6px 20px rgba(0,0,0,0.5)',
  backdropFilter: 'blur(3px)',
  WebkitBackdropFilter: 'blur(3px)',
};

// ── HUD 박스 V2 「레퍼런스 충실」 ────────
//
// 1차(08-04 오전)에는 **큰 창 8개만** 옮겼다 — HUD 조각은 이미 HUD_BOX 로 통일돼 있으니
// 그대로 두자는 판단이었다. 그게 틀렸다: 큰 창은 **가끔 여는 것**이고 HUD 조각은 **항상 떠
// 있는 것**이라, 하단 독이 새 상자가 되자마자 옆 조각들이 나란히 낡아 보였다("PC HUD 가
// 아직도 조잡하다", 명관님 2026-08-04). 통일의 기준선은 **상시 보이는 쪽**이어야 한다.
// → 2차에서 상시 조각도 V2 로 옮긴다. HUD_BOX 는 남는다(원형 버튼처럼 모서리 컷이 틀린
//   자리, 그리고 롤백 경로). 롤백은 className 을 떼고 스프레드를 되살리면 끝.
//
// 실체는 index.css 의 `.hudbox-v2*` 다(헤더 마름모·슬롯 노치가 가상요소라 인라인 style 로는
// 표현이 안 된다). 여기선 **이름만** 내보내 import 지점을 HUD_BOX 와 같은 곳에 둔다.
//
// ⚠ 이식할 때 `style={{ ...HUD_BOX }}` 스프레드를 **지우고** className 을 준다.
//    인라인 style 은 클래스를 항상 이기므로, 남겨 두면 V2 가 조용히 안 먹는다.
// ⚠ clip-path 가 자식의 드롭다운·툴팁을 자른다 → 그런 패널은 HUD_BOX_V2_FLAT 을 같이 준다.
export const HUD_BOX_V2 = 'hudbox-v2';
// 2026-08-15 (5차): 오너먼트 프레임. 상시 조각은 금선(가늘게)이 기본이고, **가끔 여는 큰 창**만
//   한옥 창살(두껍게)로 올린다 — 무게가 곧 위계다. 실체는 index.css `.hudbox-v2--ornate`.
//   ⚠ 작은 판에 ORNATE 를 주지 않는다: 20px 테두리가 판 안쪽을 다 먹는다.
export const HUD_BOX_V2_ORNATE = 'hudbox-v2 hudbox-v2--ornate';
export const HUD_BOX_V2_FLAT = 'hudbox-v2 hudbox-v2--flat';
// 프레임을 끄고 질감·모서리 컷만 받는다. 두 자리에 쓴다:
//   ① **테두리 색이 신호인 판** — 토스트(등급·경보)·렌더 배너(오류/경고/정보). 10px 장식이
//      1px 색선을 통째로 덮어 「무슨 색이었나」가 사라진다. 신호가 장식보다 위다.
//   ② **개발용 HUD** — DebugHUD·PerfHud. 유저가 볼 판이 아니라 위계를 줄 이유가 없다.
export const HUD_BOX_V2_NOFRAME = 'hudbox-v2 hudbox-v2--noframe';

// ── 프레임 두께 급 ────────────────────────────────────────────
// **두께는 취향이 아니라 에셋의 슬라이스가 정한다.** gold_deco.png 는 256px 이미지에
// slice 122 라 모서리 장식이 122px 짜리다 — 그걸 10px 에 그리면 12:1 로 뭉개져
// 「금색 두 줄」이 된다(5차가 그 상태였다). 가독 하한이 약 16px.
// 급은 **짧은 변의 약 13%** 에서 나왔고, 실체·근거는 index.css `.hudbox-v2--frame-*`.
//   THIN 6px  — 짧은 변 60px 미만(채팅 바 33 · 시계 칩 51). 하한 미만이라 장식을 포기하고
//               헤어라인으로 읽히게 두는 자리. 10px 이면 위아래 프레임이 서로 닿는다.
//   MD   16px — 짧은 변 100~200px 상시 판(좌상단 캐릭터 카드 331×122).
//   LG   22px — 화면을 가로지르는 띠(하단 독). 폭이 6배 넘으면 같은 두께가 가늘어 보인다.
export const HUD_BOX_V2_THIN = 'hudbox-v2 hudbox-v2--frame-thin';
/** 또렷한 가장자리 — **밝은 배경 위에 뜨는 판**에 같이 준다(채팅). 금선 한 줄은 낮 지형에서
 *  명도 대비가 거의 0 이라 경계가 안 잡힌다. 어두운 테를 바깥에 하나 더 두른다(index.css). */
export const HUD_BOX_V2_EDGE = 'hudbox-v2--edge';
export const HUD_BOX_V2_MD = 'hudbox-v2 hudbox-v2--frame-md';
export const HUD_BOX_V2_LG = 'hudbox-v2 hudbox-v2--frame-lg';
// 스크롤 상자 전용 — `overflow:auto` 판은 ::after 가 내용과 같이 **스크롤돼 사라진다**.
// 진짜 border 로 그려 스크롤을 안 타게 한다(전역 border-box 라 바깥 치수는 그대로).
// 쓰는 판은 padding 을 20px 만큼 덜어 준다.
export const HUD_BOX_V2_SCROLLFRAME = 'hudbox-v2 hudbox-v2--scrollframe';

/** 필 텍스처(판 «안쪽» 의 결). 실체는 index.css `.hudbox-v2--paper*`.
 *  ⚠ 프레임(::after)과 축이 다르므로 **같이 준다** — `${HUD_BOX_V2_ORNATE} ${HUD_BOX_V2_PAPER}`.
 *  ⚠ 작은 칩엔 주지 마라(256px 무늬가 40px 판에서는 얼룩 한 점이다). */
export const HUD_BOX_V2_PAPER = 'hudbox-v2--paper';                       // 한지
export const HUD_BOX_V2_HEAD = 'hudbox-v2__head';
export const HUD_BOX_V2_SLOT = 'hudbox-v2__slot';
export const HUD_BOX_V2_BTN = 'hudbox-v2__btn';
// 프레임 두른 버튼 — 우측 레일처럼 **창을 여는 진입점**에만. 하단 독 52px 슬롯 줄에는
//   안 준다(거기는 「칸」의 문법이고, 52px 에 프레임이면 아이콘이 죽는다는 치수 논증이
//   그대로 살아 있다). 두께 근거·A/B 는 index.css `.hudbox-v2__btn--framed` 주석.
export const HUD_BOX_V2_BTN_FRAMED = 'hudbox-v2__btn hudbox-v2__btn--framed';

// ── HUD 크기 3단 토큰 ─────────────
//
// 여태 HUD 조각은 **자기 크기를 자기가 정했다**. 실측하니 한 화면에 다섯 자가 있었다:
//   스킬 퀵슬롯 56 · 자동/소비/채집 46 · 하단 바 시스템 아이콘 34 ·
//   미니맵 밑 툴 28(미니맵 폭 파생) · MENU 행 아이콘 26.
// 각각은 그때그때 근거가 있었지만(툴은 미니맵 폭에서 나왔고, 46 은 오브 시절 잔재),
// **합쳐 놓으면 근거가 안 보인다** — 그게 「비율이 안 맞는다」의 정체다(명관님 2026-08-06).
//
// 그래서 값이 아니라 **급(rank)** 을 정한다. 급은 「얼마나 자주 누르나」로 가른다:
//   lg — 전투 조작. 매초 누른다. 스킬 퀵슬롯.
//   md — 보조 조작. 전투 중에 가끔 누른다. 자동사냥 · 소비 슬롯 · 채집.
//   sm — 진입점. 창을 여는 버튼이라 **누르는 빈도가 아니라 찾는 빈도**가 중요하다.
//        하단 바 시스템 아이콘 · 미니맵 밑 툴 격자 · MENU 패널 행 · 골드 칩 높이.
// 값(56/44/32)보다 **「같은 급끼리 같은 크기」**가 요점이다. 값을 고치려면 여기만 고친다.
//
// ⚠ 이 숫자는 **로직 px** 이다. 실화면 크기는 배율이 곱해진다 —
//   하단 바는 barScale, 우상단 컬럼은 hudScale(둘 다 GameOverlay.jsx). 두 배율이 갈리는
//   화면(좁은 폭)에서는 같은 급도 화면에서 다른 크기가 된다. 그건 의도다: 좁아지면
//   전투 조작을 지키고 나머지가 준다.
// ⚠ **미니맵 툴 격자는 이제 폭을 미니맵에서 안 받는다.** 반대로 미니맵 기본 폭이
//   「sm 3칸 + 간격 2」에서 나온다(GameOverlay.jsx minimapWidth). 컬럼 정렬을 지키면서
//   토큰을 지키는 길은 그 방향뿐이다 — 칸 크기를 슬라이더에 물리면 급이 무너진다.
// ── 2026-08-07 2차 개정 (명관님 실화면 지적) ────────────────────────────────
// 1차는 급을 「누르는 빈도」로 갈랐다. 실화면에서 깨진 건 그 갈래가 아니라 **한 줄 안에
// 두 크기가 서 있는 것**이었다: 슬롯 줄이 [스킬 56][자동 44][소비 44][채집 44] 라
// 한 덩어리로 안 읽히고 「큰 것 옆에 작은 것들」로 보였다.
// → **줄이 크기의 단위다.** 같은 줄에 있으면 같은 크기다. 급은 줄과 줄 사이에서만 갈린다.
//   lg 52 — 하단 바 슬롯 줄 **전체**(스킬·자동·소비·채집). 56→52 는 11칸이 한 줄에
//           서면서 폭이 늘어난 만큼 되돌린 값이다(6칸 시절의 56 은 11칸엔 과하다).
//   md 40 — 진입점 버튼. 하단 바 시스템 아이콘과 미니맵 밑 툴이 **같은 크기**여야 한다
//           (그 둘이 다른 크기인 것이 1차의 원래 지적이었다). 32 는 52 옆에서 너무 작았다.
//   sm 32 — 리스트·타일 안의 아이콘, 칩 높이. 버튼이 아니라 **글자와 같이 서는 것**.
export const HUD_SIZE = {
  lg: 52,
  md: 40,
  sm: 32,
  /** 같은 급끼리의 간격. 급이 갈리는 자리(구획선 양옆)는 8 을 쓴다. */
  gap: 6,
};
/** 정사각 버튼 안의 아이콘 크기 — railButton 이 쓰던 0.45 비율을 토큰으로 올린 것. */
export const hudIcon = (size) => Math.round(size * 0.45);

/**
 * 하단 전투 줄(HP·레벨·MP)의 «판 높이» — 칸 높이에서 파생된다.
 *
 * 셋이 각자 계산하면 한 줄로 안 읽힌다: 게이지 판만 눕히고 레벨 칩이 칸을 다 쓰면
 * 실루엣이 울퉁불퉁해진다. 그래서 값 하나를 두 파일(`BottomDock`·`LevelBadge`)이 쓴다.
 * 상한 40 — 칸을 세로로 여러 칸 잡아도 줄만 계속 굵어지면 위계가 다시 무너진다.
 */
export const hudBandH = (boxH) => Math.max(24, Math.min(40, Math.round(boxH * 0.5) + 6));

/** 토스트 색 — **등급 + 등급이 아닌 것**이 한 표에 산다(gold·denied·teleport 는 알림 종류다).
 *  등급 쪽은 `@ui/rarity` 를 그대로 쓴다 — 여기 사본이 따로 놀아서 같은 전설 아이템이
 *  획득 토스트에선 주황(#ffaa00), 인벤에선 금색(#fbbf24)이었다(2026-08-10). */
export const RARITY_COLOR = {
  ...RARITY_HEX,
  gold: '#d0b16b',
  denied: '#ff8a5a',
  teleport: '#67e8d6',
};
